// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as DragComponent} from './Drag.svg';

import Icon, { TIconProps } from '../Icon';

export const IconDrag = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <DragComponent/>
  </Icon>
));
